import { BUSINESS_TRAVELLER_APPROVER_ROLES } from 'businessTraveller/constants/businessTravellerEmployeeRoleConstants'
import {
  BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE,
  BUSINESS_TRAVELLER_MY_APPROVALS_ROUTE,
  BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ACTIVE_ROUTE,
  BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ROUTE,
  BUSINESS_TRAVELLER_ROOT_ROUTE,
} from 'components/App/Routes/routeConstants'
import LineBagIcon from 'LuxKit/Icons/line/LineBagIcon'
import LineExcursionIcon from 'LuxKit/Icons/line/LineExcursionIcon'
import LineFileCheckAltIcon from 'LuxKit/Icons/line/LineFileCheckAltIcon'
import LineFileQuestionAltIcon from 'LuxKit/Icons/line/LineFileQuestionAltIcon'
import LineUserCircleIcon from 'LuxKit/Icons/line/LineUserCircleIcon'
import SolidBagIcon from 'LuxKit/Icons/solid/SolidBagIcon'
import SolidFileCheckAltIcon from 'LuxKit/Icons/solid/SolidFileCheckAltIcon'
import SolidFileQuestionAltIcon from 'LuxKit/Icons/solid/SolidFileQuestionAltIcon'
import SolidUserCircleIcon from 'LuxKit/Icons/solid/SolidUserCircleIcon'
import { SvgIconComponent } from 'LuxKit/SvgIcon'

export type AppBottomNavTabId = 'search' | 'bookings' | 'trip-requests' | 'approvals' | 'account'

/** What a tab does in place of navigating */
export type AppBottomNavTabAction = 'account-menu'

export interface AppBottomNavTabConfig {
  id: AppBottomNavTabId
  label: string
  /** Region-less route, the link adds the current region. Omitted for a tab that runs an `action` */
  to?: string
  /** Route patterns (with `/:regionCode`) that highlight this tab. An action tab is never highlighted */
  activeRoutes?: Array<string>
  /** Takes an action on clicking the tab */
  action?: AppBottomNavTabAction
  icon: SvgIconComponent
  /** Shown while the tab is active. Same as `icon` when the icon set has no solid variant */
  activeIcon: SvgIconComponent
  /** When set, the tab only renders for employees holding one of these roles */
  employeeRoles?: Array<App.BusinessTraveller.EmployeeRole>
}

/**
 * Tabs in display order. Search, My Bookings, Trip Requests and Account always show;
 * My Approvals slots in after Trip Requests for approvers only.
 * Account opens the account menu drawer rather than navigating, so it has no route of its own.
 */
export const APP_BOTTOM_NAV_TABS: Array<AppBottomNavTabConfig> = [
  {
    id: 'search',
    label: 'Search',
    to: BUSINESS_TRAVELLER_ROOT_ROUTE,
    activeRoutes: [`/:regionCode${BUSINESS_TRAVELLER_ROOT_ROUTE}`],
    icon: LineExcursionIcon,
    activeIcon: LineExcursionIcon,
  },
  {
    id: 'bookings',
    label: 'Bookings',
    to: '/account/my-bookings',
    activeRoutes: ['/:regionCode/account/my-bookings/:tab(upcoming|cancelled|past|active-trip-requests)?'],
    icon: LineBagIcon,
    activeIcon: SolidBagIcon,
  },
  {
    id: 'trip-requests',
    label: 'Requests',
    to: BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ACTIVE_ROUTE,
    activeRoutes: [`/:regionCode${BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ROUTE}/:tab(active|history)?`],
    icon: LineFileQuestionAltIcon,
    activeIcon: SolidFileQuestionAltIcon,
  },
  {
    id: 'approvals',
    label: 'Approvals',
    to: BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE,
    activeRoutes: [`/:regionCode${BUSINESS_TRAVELLER_MY_APPROVALS_ROUTE}/:tab(pending|history)?`],
    icon: LineFileCheckAltIcon,
    activeIcon: SolidFileCheckAltIcon,
    employeeRoles: BUSINESS_TRAVELLER_APPROVER_ROLES,
  },
  {
    id: 'account',
    label: 'Account',
    action: 'account-menu',
    icon: LineUserCircleIcon,
    activeIcon: SolidUserCircleIcon,
  },
]
